import { Component, Input } from '@angular/core';
import { JwtService } from '../../Services/jwt.service';
import { TitleService } from '../../Services/title.service';
import { UserType } from '../../Constants/user-type';
import { UserService } from 'src/app/user/Services/user.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { supplierService } from 'src/app/supplier/services/supplier.service';
import { JobSeekerService } from 'src/app/job-seeker/Services/job-seeker.service';
import { ActivatedRoute } from '@angular/router';
import { LoggingService } from '../../Services/NGLogger/logging-service.service';

@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.css']
})
export class ProfileViewComponent {
  @Input() profileImage: any
  UserId: any;
  UserType: string = '';
  UType: any;
  isverifyBtn: boolean = false;
  staffAData: any = [];
  EmailId: any;
  constructor(
    private jwtService: JwtService,
    private titleService: TitleService,
    private userService: UserService,
    private toastr: ToastrManager,
    private supplierService: supplierService,
    private jobSeekerService: JobSeekerService,
    private loggingService: LoggingService,
    private paramVal: ActivatedRoute
  ) {
    this.paramVal.queryParams.subscribe((params: any) => {
      this.UserId = params['id'];
    });
    this.titleService.setTitle('Profile Summary')
    this.UserType = jwtService.getUserType();
    this.UType = UserType;
  }

  clearFile(event: Event): void {
    // Clear file input here
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = ''; // Clear the selected file
  }
  resetPaswordLinkSent(email: string) {
    this.userService.resetPassword(email).subscribe((res: any) => {
      if (res.succeeded) {
        this.toastr.successToastr(res.messages[0], "", "top-right");
      } else {
        this.toastr.errorToastr(res.messages[0], "", "top-right");
      }
    });
  }
  async onSelect(event: any) {
    const { fileName, base64, error } = await this.onFileSelected(event);
    this.UploadImage(base64, fileName);
  }

  async onFileSelected(event: any): Promise<{ fileName: string, base64: string, error?: string }> {
    const fileInput = event.target;
    if (fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const fileName = file.name;
      const fileType = file.type;
      const validTypes = ['image/png', 'image/jpeg'];
      if (!validTypes.includes(fileType)) {
        return { fileName: '', base64: '', error: 'Invalid file type. Only .png, .jpg, and .jpeg are allowed.' };
      }
      const base64 = await this.readBase64(file);
      return { fileName, base64 };
    } else {
      return { fileName: '', base64: '' };
    }
  }

  private readBase64(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        resolve(reader.result as string);
      });
      reader.addEventListener('error', (event) => {
        reject(event);
      });
      reader.readAsDataURL(file);
    });
  }

  UploadImage(file: any, fileName: any) {
    const File = file;
    const FileName = fileName;
    if (this.UserType == UserType.Supplier) {
      const ImageModel = {
        File: File,
        Name: FileName,
        SupplierId: this.UserId
      }
      this.supplierService.UploadImage(ImageModel)
        .subscribe((res: any) => {
          if (res.succeeded) {
            this.profileImage = res.data.file;
            this.staffAData.file = res.data.file;
            this.toastr.successToastr(res.messages[0], 'Success!');
          } else {
            this.toastr.errorToastr(res.messages[0], 'Error!');
          }
        },
        );
    }
    else if (this.UserType == UserType.JobSeeker) {
      const ImageModel = {
        Type: "IMAGE",
        File: File,
        Name: FileName,
        JsId: this.UserId
      }
      this.jobSeekerService.UploadImage(ImageModel)
        .subscribe((res: any) => {
          if (res.succeeded) {
            this.profileImage = res.data.file;
            this.staffAData.file = res.data.file;
            this.toastr.successToastr(res.messages[0], 'Success!');
          } else {
            this.toastr.errorToastr(res.messages[0], 'Error!');
          }
        },
          err => { this.loggingService.captureException(err); }
        );
    }
  }

}
